import { render, staticRenderFns } from "./babyage.vue?vue&type=template&id=da5ef360&scoped=true"
import script from "./babyage.vue?vue&type=script&lang=js"
export * from "./babyage.vue?vue&type=script&lang=js"
import style0 from "./babyage.vue?vue&type=style&index=0&id=da5ef360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5ef360",
  null
  
)

export default component.exports